/* ==========================================================================
   OSERE — Aparición del círculo de «The Eye Opening Effect»

   El óvalo aparece completo con un fundido y un leve realce cuando la sección
   entra en pantalla, tras un pequeño retardo. No se traza línea a línea.

   Regla de fallo: si el script no corre, o hay «movimiento reducido», el óvalo
   se ve completo desde el inicio. La animación se añade; nunca esconde algo que
   ya funcionaba.
   ========================================================================== */

(function () {
  'use strict';

  var QUIETO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function montar(svg) {
    if (svg.dataset.osMontado) return;
    svg.dataset.osMontado = '1';

    var retardo = parseInt(svg.getAttribute('data-os-trazo-delay'), 10);
    if (isNaN(retardo)) retardo = 500;

    var mostrado = false;
    function mostrar() {
      if (mostrado) return;
      mostrado = true;
      svg.classList.add('os-camp__trazo--dentro');
    }

    // Sin animación posible: se ve completo y punto.
    if (QUIETO || !('IntersectionObserver' in window)) {
      return;
    }

    // Arma el estado oculto (el CSS lo esconde con --armado).
    svg.classList.add('os-camp__trazo--armado');

    /* En el editor de Shopify (designMode) el observador de aparición no es
       fiable: el preview re-renderiza y a menudo no dispara. Para que la clienta
       VEA la animación mientras configura, se muestra sola tras el retardo. */
    if (window.Shopify && window.Shopify.designMode) {
      setTimeout(mostrar, retardo + 150);
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].isIntersecting) continue;
          obs.unobserve(entradas[i].target);
          setTimeout(mostrar, retardo);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );
    obs.observe(svg);

    /* Red de seguridad: si el observer nunca dispara (pestaña que nació oculta),
       igual se muestra. */
    setTimeout(mostrar, retardo + 3500);
  }

  function init(ambito) {
    var svgs = (ambito || document).querySelectorAll('.os-camp__trazo');
    for (var i = 0; i < svgs.length; i++) montar(svgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  // El personalizador reconstruye la sección al editarla.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
